import { useEffect, useState } from 'react';
import React from 'react';
import { CopyOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import './index.less';
import { useCommand } from '../../../../../hooks';
import Popover from './components/Popover';
import { Ellipsis, Icon } from '../../../common';
import { getElementCategory } from '../../../../../model';
export const dispatchReactComponentUpdate = (rootDom, config) => {
    const event = new CustomEvent(`react-node-update`, { detail: config });
    rootDom === null || rootDom === void 0 ? void 0 : rootDom.dispatchEvent(event);
};
export const useReactNodeConfig = ({ instance, parentDom, }) => {
    const nodeConfig = instance.getConfig();
    const { highlight } = instance;
    const [config, setConfig] = useState(Object.assign(Object.assign({}, nodeConfig), { highlight }));
    useEffect(() => {
        const listener = data => {
            setConfig(data.detail);
        };
        parentDom === null || parentDom === void 0 ? void 0 : parentDom.addEventListener('react-node-update', listener);
        return () => {
            parentDom === null || parentDom === void 0 ? void 0 : parentDom.removeEventListener(`react-node-update`, listener);
        };
    }, [parentDom]);
    return [config, instance.setConfig];
};
const ElementBottomTools = (props) => {
    var _a, _b;
    const { instance, config } = props;
    const oFlowModel = instance.model;
    const oFlowId = oFlowModel.getOFlowId();
    const { quickTools, primaryColor, canvasId } = instance;
    const { highlight } = config;
    const editable = (_b = (_a = instance === null || instance === void 0 ? void 0 : instance.canvasModel) === null || _a === void 0 ? void 0 : _a.oFlowModel) === null || _b === void 0 ? void 0 : _b.getEditable();
    const { quickDelete, quickDuplicate, recommendNext, recommendPrevious } = quickTools;
    const command = useCommand({ canvasId, oFlowId });
    const canvasModel = instance === null || instance === void 0 ? void 0 : instance.canvasModel;
    const [quickAddElementVisible, setQuickAddElementVisible] = useState(false);
    useEffect(() => {
        if (!highlight) {
            setQuickAddElementVisible(false);
        }
    }, [highlight]);
    const handleRemove = () => {
        command.execute('BATCH_DELETE_ELEMENTS', { payload: [instance.id] });
    };
    const handleDuplicate = () => {
        command.execute('BATCH_PASTE_ELEMENTS', { payload: { nodes: [instance === null || instance === void 0 ? void 0 : instance.getConfig()] } });
    };
    const handleAddElement = () => {
        setQuickAddElementVisible(visibile => {
            return !visibile;
        });
    };
    const renderNextElements = () => {
        const handleAddNextElement = (nextConfig) => {
            const { left, top, width, height, id } = instance.getConfig();
            const category = getElementCategory(nextConfig);
            const ElementClass = category === 'NODE'
                ? oFlowModel.nodeTypeMap[nextConfig.type]
                : category === 'GROUP'
                    ? oFlowModel.groupTypeMap[nextConfig.type]
                    : null;
            let nextWidth = nextConfig.width || ElementClass.defaultConfig.width;
            let nextHeight = nextConfig.height || ElementClass.defaultConfig.height;
            const { direction, levelSpacing } = canvasModel === null || canvasModel === void 0 ? void 0 : canvasModel.rankConfig;
            let nextLeft;
            let nextTop;
            if (direction === 'vertical') {
                nextLeft = (width - nextWidth) / 2 + left;
                nextTop = top + height + levelSpacing;
            }
            else if (direction === 'horizontal') {
                nextLeft = left + width + levelSpacing;
                nextTop = (height - nextHeight) / 2 + top;
            }
            const nextElementId = category === 'GROUP'
                ? oFlowModel.generateOFlowCanvasGroupId()
                : oFlowModel.generateOFlowCanvasNodeId();
            const nextEdgeId = oFlowModel.generateOFlowCanvasEdgeId();
            const newNextElementConfig = Object.assign(Object.assign({}, nextConfig), { left: nextLeft, top: nextTop, id: nextElementId });
            const edgeConfig = { id: nextEdgeId, source: id, target: nextElementId };
            command.execute('BATCH_ADD_ELEMENTS', {
                payload: {
                    edges: [edgeConfig],
                    nodes: [newNextElementConfig],
                },
            });
        };
        return (React.createElement("div", { className: "oflow--element-tool--node-action-overlay--resource" }, recommendNext === null || recommendNext === void 0 ? void 0 : recommendNext.map((item, index) => {
            return (React.createElement("div", { key: index, className: "oflow--element-tool--node-action-overlay--resource--item", onClick: () => {
                    handleAddNextElement(item);
                } },
                React.createElement(Icon, { icon: item.icon, className: "oflow--element-tool--node-action-overlay--resource--item--icon" }),
                React.createElement(Ellipsis, null, item.label)));
        })));
    };
    return editable && highlight ? (React.createElement("div", { className: "oflow--element-tool-wrapper oflow--element-tool-wrapper--bottom stop-propagation" },
        quickDuplicate ? (React.createElement("div", { className: "oflow--element-tool", style: { backgroundColor: primaryColor }, onClick: handleDuplicate },
            React.createElement(Tooltip, { title: "\u590D\u5236", placement: "bottom", overlayStyle: { pointerEvents: 'none' } },
                React.createElement(CopyOutlined, null)))) : null,
        quickDelete ? (React.createElement("div", { className: "oflow--element-tool", style: { backgroundColor: primaryColor }, onClick: handleRemove },
            React.createElement(Tooltip, { title: "\u5220\u9664", placement: "bottom", 
                // className='oflow--element'
                overlayStyle: { pointerEvents: 'none' } },
                React.createElement(DeleteOutlined, null)))) : null,
        (recommendNext === null || recommendNext === void 0 ? void 0 : recommendNext.length) ? (React.createElement("div", { className: "oflow--element-tool", style: { backgroundColor: primaryColor }, onClick: handleAddElement },
            React.createElement(Tooltip, { title: "\u5FEB\u901F\u6DFB\u52A0", placement: "bottom", overlayStyle: { pointerEvents: 'none' } },
                React.createElement(PlusOutlined, null)))) : null,
        React.createElement(Popover, { visible: quickAddElementVisible, className: "oflow--element-tool--node-action-overlay", style: {
                position: 'absolute',
                top: 4,
                right: 0,
                transform: 'translateX(100%)',
            } }, renderNextElements()))) : null;
};
const ElementTopTools = (props) => {
    var _a, _b;
    const { instance, config } = props;
    const oFlowModel = instance.model;
    const oFlowId = oFlowModel.getOFlowId();
    const { quickTools, primaryColor, canvasId } = instance;
    const { highlight } = config;
    const editable = (_b = (_a = instance === null || instance === void 0 ? void 0 : instance.canvasModel) === null || _a === void 0 ? void 0 : _a.oFlowModel) === null || _b === void 0 ? void 0 : _b.getEditable();
    const { recommendPrevious } = quickTools;
    const command = useCommand({ canvasId, oFlowId });
    const canvasModel = instance.canvasModel;
    const [quickAddElementVisible, setQuickAddElementVisible] = useState(false);
    useEffect(() => {
        if (!highlight) {
            setQuickAddElementVisible(false);
        }
    }, [highlight]);
    const handleAddElement = () => {
        setQuickAddElementVisible(visibile => {
            return !visibile;
        });
    };
    const renderPreviousElements = () => {
        const handleAddpreviousElement = (previousConfig) => {
            const { left, top, width, height, id } = instance.getConfig();
            const category = getElementCategory(previousConfig);
            const ElementClass = category === 'NODE'
                ? oFlowModel.nodeTypeMap[previousConfig.type]
                : category === 'GROUP'
                    ? oFlowModel.groupTypeMap[previousConfig.type]
                    : null;
            let previousWidth = previousConfig.width || ElementClass.defaultConfig.width;
            let previousHeight = previousConfig.height || ElementClass.defaultConfig.height;
            const { direction, levelSpacing } = canvasModel.rankConfig;
            let previousLeft;
            let previousTop;
            if (direction === 'vertical') {
                previousLeft = left + (width - previousWidth) / 2;
                previousTop = top - (previousHeight + levelSpacing);
            }
            else if (direction === 'horizontal') {
                previousLeft = left - (previousWidth + levelSpacing);
                previousTop = top + (height - previousHeight) / 2;
            }
            const previousElementId = category === 'GROUP'
                ? oFlowModel.generateOFlowCanvasGroupId()
                : oFlowModel.generateOFlowCanvasNodeId();
            const previousEdgeId = oFlowModel.generateOFlowCanvasEdgeId();
            const newPreviousElementConfig = Object.assign(Object.assign({}, previousConfig), { left: previousLeft, top: previousTop, id: previousElementId });
            const edgeConfig = { id: previousEdgeId, source: previousElementId, target: id };
            command.execute('BATCH_ADD_ELEMENTS', {
                payload: {
                    edges: [edgeConfig],
                    nodes: [newPreviousElementConfig],
                },
            });
        };
        return (React.createElement("div", { className: "oflow--element-tool--node-action-overlay--resource" }, recommendPrevious === null || recommendPrevious === void 0 ? void 0 : recommendPrevious.map((item, index) => {
            return (React.createElement("div", { key: index, className: "oflow--element-tool--node-action-overlay--resource--item", onClick: () => {
                    handleAddpreviousElement(item);
                } },
                React.createElement(Icon, { icon: item.icon, className: "oflow--element-tool--node-action-overlay--resource--item--icon" }),
                React.createElement(Ellipsis, null, item.label)));
        })));
    };
    return editable && highlight ? (React.createElement("div", { className: "oflow--element-tool-wrapper oflow--element-tool-wrapper--top stop-propagation" },
        (recommendPrevious === null || recommendPrevious === void 0 ? void 0 : recommendPrevious.length) ? (React.createElement("div", { className: "oflow--element-tool", style: { backgroundColor: primaryColor }, onClick: handleAddElement },
            React.createElement(Tooltip, { title: "\u5FEB\u901F\u6DFB\u52A0", placement: "bottom", overlayStyle: { pointerEvents: 'none' } },
                React.createElement(PlusOutlined, null)))) : null,
        React.createElement(Popover, { visible: quickAddElementVisible, className: "oflow--element-tool--node-action-overlay", style: {
                position: 'absolute',
                bottom: 4,
                right: 0,
                transform: 'translateX(100%)',
            } }, renderPreviousElements()))) : null;
};
const ComponentWrapper = (props) => {
    var _a, _b;
    const { instance } = props;
    const { id } = instance;
    const { ReactComponent } = instance.constructor;
    const [parentDom, setParentDom] = useState();
    const [config, setConfig] = useReactNodeConfig({ instance, parentDom });
    const editable = (_b = (_a = instance === null || instance === void 0 ? void 0 : instance.canvasModel) === null || _a === void 0 ? void 0 : _a.oFlowModel) === null || _b === void 0 ? void 0 : _b.getEditable();
    return (React.createElement("div", { "oflow-element-id": id, style: { cursor: editable ? 'move' : 'pointer' }, ref: dom => {
            setParentDom(dom);
        } },
        React.createElement(ElementTopTools, { instance: instance, config: config }),
        React.createElement(ReactComponent, { config: config, setConfig: setConfig, instance: instance }),
        React.createElement(ElementBottomTools, { instance: instance, config: config })));
};
export const ReactComponentWrapper = ComponentWrapper;
//# sourceMappingURL=react-node-utils.js.map